module.exports = __webpack_public_path__ + "img/img-12.caf672c0.jpg";